import type { ProgressReportMessage } from '@brighterly/lib-core-types/progress-report/interfaces'
import type { ProgressReportStore } from '../model/store/interfaces'

import { getReport } from './report'

const getMessage = (state: ProgressReportStore): ProgressReportMessage | null => getReport(state)?.message || null

export const message = {
  getMessage: (state: ProgressReportStore): ProgressReportMessage | null => getMessage(state),
  getWins: (state: ProgressReportStore): string => getMessage(state)?.wins || '',
  getFriction: (state: ProgressReportStore): string => getMessage(state)?.friction || '',
  getBuds: (state: ProgressReportStore): string => getMessage(state)?.buds || '',
}
